import { render } from "./ProductionTest.vue?vue&type=template&id=f3a4dc80"
import script from "./ProductionTest.vue?vue&type=script&lang=ts"
export * from "./ProductionTest.vue?vue&type=script&lang=ts"
script.render = render

export default script